import React, {Component} from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {connect}  from  "react-redux";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');

 var th = moment().startOf('isoMonth');
// console.log(moment(th).format('MMM YYYY'))

var ss = moment().subtract(1, 'months').startOf('isoMonth')
// console.log(moment(ss).format('MMM YYYY'))

Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
class EmiScheme extends Component{
    constructor(props) {
        super(props);
        this.state ={
            _notificationSystem: null,
            dateTo:tod,
            dateLimit:date_limit,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            FrequencyList:[{value:"daily", label: "Daily"},{value:"weekly", label: "Weekly"},{value:"monthly", label: "Monthly"}],
            frequency:'',
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true
        }
    }
  componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);

            this._get_filtered_emi_scheme_report('','','','','','', this.state.yestSend, this.state.todSend);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: false,
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else{
            this.unauthrize_acess();
        }
        this._getAllMerchants();
        this._get_acq_banks();
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("support_module")===false  || reportPermissions.includes("emi_scheme")===false ){
            this.unauthrize_acess();
        }

    }
    unauthrize_acess(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    _get_acq_banks() {
        axios.get(config.get('API_URL')+'/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(response.data.data != null) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading: false
        })
    }

    change_acq_banks(optionSelected) {
        //console.log(optionSelected);
        let value = '';
        let acqBankArray = [];
        if (optionSelected.length<1) {
            value = null;
            acqBankArray = '';
        } else {
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        this.setState({
            acqBankIds: acqBankArray,
            acqBankValue: optionSelected,
        });
        this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,this.state.frequency,
            this.state.yestSend, this.state.todSend);
    }
    _get_filtered_emi_scheme_report(mids, cids, sids, bids, cityids, fr, fromdate, todate) {
        disabledBody()
        //console.log(mids); console.log(cids); console.log(sids); console.log(bids); console.log(cityids); console.log(fr);
        var postData = {
            mids: mids,
            cids: cids,
            sids: sids,
            bids: bids,
            yestSend: fromdate,
            todSend: todate
        };
        if ($.fn.DataTable.isDataTable('#EmiTable')) {
            $('#EmiTable').DataTable().clear().destroy();
        }
        var EmiReports = $('#EmiTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                //"autoWidth": false,
                "responsive": false,
                "sPaginationType": "numbers",
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/emi-scheme-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        enabledBody();
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },
                columns: [
                    {"data":"Merchant",  "width": "150px",},
                    {"data":"Chain", "width": "100px"},
                    {"data":"Store Name",  "width": "100px"},
                    {"data":"Store Address"},
                    {"data":"Acquiring Bank"},
                    {"data":"Store Pin code"},
                    {"data":"UTID enabled on EMI"},
                    {"data":"Scheme Name"},
                    {"data":"Scheme Start Date"},

                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "80px",
                        "targets": 8
                    },
                ],

            });
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            response.data.map((merchant,index) => {
                this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
            });
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });

        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        });

        this._get_filtered_emi_scheme_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,this.state.frequency,
            this.state.yestSend, this.state.todSend);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }
    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
            });
        }

        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: []
        });
        this._get_filtered_emi_scheme_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds, this.state.frequency,
            this.state.yestSend, this.state.todSend);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }

    changeStore(login_type, optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value == sids.value);
                    this.state.storeList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,this.state.frequency,
            this.state.yestSend, this.state.todSend);
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this._get_filtered_emi_scheme_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds, this.state.frequency,
                this.state.yestSend, this.state.todSend)
        }
    }
    emiSchemeDownload (e){
        this.setState({
            is_download: false,
            model_visible: true,
            file_url:''
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            download: true,

        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/emi-scheme-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                type: "octet/stream"
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName = timestamp+'emi_scheme.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }

    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
                margin: "0px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px",
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px",
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "15px",
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px',
            }),
            menu: styles => ({ ...styles, zIndex: 999,})
        };

        return(
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">EMI Scheme</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo}
                                                             onEvent={this.handleEvent.bind(this)} maxDate = {this.state.dateLimit}>
                                                <i className="fa fa-calendar" aria-hidden="true"></i>
                                                <input type="text" name="dateRange"
                                                       className="form-control dateRangeInput"
                                                       value={this.state.datefromShow + ' - ' + this.state.dateToShow}/>
                                            </DateRangePicker>
                                        </div>
                                        {this.state.merchant_list_box ===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Merchants</label>
                                            <ReactMultiSelectCheckboxes name="merchants"
                                                    isMulti
                                                    value={this.state.merchantValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeMerchant.bind(this,'')}
                                                    options={this.state.merchantList}
                                                    placeholderButtonLabel="Select [Merchant]"
                                            />

                                            <div className="clearfix"></div>
                                        </div> : null}
                                        {this.state.chain_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Chain </label>
                                            <ReactMultiSelectCheckboxes name="chain"
                                                    isMulti
                                                    components={{ MenuList }}
                                                    value={this.state.chainValue}
                                                    styles={customStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.changeChain.bind(this,'')}
                                                    options={this.state.chainList}
                                                    placeholderButtonLabel="Select [Chain]"
                                            />
                                            <div className="clearfix"></div>
                                        </div> : null }
                                        {this.state.store_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Store </label>
                                            <ReactMultiSelectCheckboxes name="store"
                                                                        isMulti
                                                                        isLoading={this.state.is_store_loading}
                                                                        components={{ MenuList }}
                                                                        value={this.state.storeValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.changeStore.bind(this, '')}
                                                                        options={this.state.storeList}
                                                                        placeholderButtonLabel="Select [Store]"
                                            />
                                            <div className="clearfix"></div>
                                        </div> : null }
                                        {/*{this.state.acq_bank_list_box===true?*/}
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Acquirer:</label>
                                            <ReactMultiSelectCheckboxes name="acqurier"
                                                isMulti
                                                value={this.state.acqBankValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.change_acq_banks.bind(this)}
                                                options={this.state.acqBankList}
                                                placeholderButtonLabel="Select [Acquirer]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>
                                        {/*:null }*/}


                                    </div>
                                    <div className="gap_ver"></div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <a href="#" className="exportButton" role="button" onClick={this.emiSchemeDownload.bind(this)}>
                                        <i className="fa fa-download" aria-hidden="true"></i>
                                        Export to CSV
                                    </a>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="EmiTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store Name</th>
                                                <th>Store Adderss</th>
                                                <th>Acquiring Bank</th>
                                                <th>Store Pin Code</th>
                                                <th>UTID enabled on EMI</th>
                                                <th>Scheme Name</th>
                                                <th>Scheme Start Date</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(EmiScheme)